import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MaxWidthTextField, TitleText, SubText } from 'cxid-common-components/util-components'
import { updateSsn, validateSsn, viewNext, trackSsnInput } from '../store/actions'

class Ssn extends PureComponent {
  render() {
    const { ssn, ssnError, dispatchUpdateSsn, dispatchValidateSsn } = this.props

    return (
      <div className="ssn">
        <TitleText hasSubtitle>Let&apos;s verify your identity.</TitleText>
        <SubText>For your security we just need to make sure it&apos;s you.</SubText>
        <MaxWidthTextField
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          autoFocus
          className="ssn-text"
          error={ssnError || ssnError.length > 0}
          fullWidth
          id="ssn"
          label="Last 4 digits of your SSN or TIN"
          maxLength="4"
          message={ssnError || ssnError.length > 0 ? ssnError : ''}
          onBlur={dispatchValidateSsn}
          onChange={dispatchUpdateSsn}
          value={ssn}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchUpdateSsn: updateSsn,
      dispatchValidateSsn: validateSsn,
      dispatchViewNext: viewNext,
      dispatchTrackSsnInput: trackSsnInput
    },
    dispatch
  )

const mapStateToProps = state => ({
  ssn: state.form.ssn,
  ssnError: state.form.ssnError
})

export default connect(mapStateToProps, mapDispatchToProps)(Ssn)
